// Sidebar "Manage projects" entry — a single row styled like the other nav items
// (icon + label + hover) for visual consistency, but WITHOUT the persistent active
// highlight: it opens the Manage Projects MODAL (create / rename / archive / delete /
// view files) rather than navigating to a page, so there's no "you are here" state to
// hold. Creating a project now lives inside that modal.
import React, { useState } from "react";
import { Folders } from "lucide-react";
import ManageProjectsModal from "./ManageProjectsModal";

export default function ProjectsNav({ onNavigate }) {
  const [manageOpen, setManageOpen] = useState(false);

  return (
    <>
      <button
        className="sidebar-nav-item"
        onClick={() => { setManageOpen(true); onNavigate && onNavigate(); }}
        title="Create, rename, archive, and view files in your projects"
      >
        <span className="sidebar-nav-icon"><Folders size={18} /></span>
        <span className="sidebar-nav-content">
          <span className="sidebar-nav-item-label">Manage projects</span>
          <span className="sidebar-nav-item-desc">Create, rename, archive, view files</span>
        </span>
      </button>

      <ManageProjectsModal open={manageOpen} onClose={() => setManageOpen(false)} />
    </>
  );
}
